// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"DeliveryOptionsField_cardContent__yBHrR","disabled":"DeliveryOptionsField_disabled__PoOTK"};